import React from 'react';
import PropTypes from 'prop-types';
import { Grid, Button, MenuItem, Select, FormControl, InputLabel } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { reduxForm, Field } from 'redux-form';
import RenderTextFieldRedux from '../Complements/RenderTextFieldRedux';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';

const useStyles = makeStyles(theme => ({
  textField: {
    width: 200,
  },
  margin: {
    margin: theme.spacing(1),
  },
}));
const validate = values => {
    const error  = {}
    if (!values.name) {
        error.name = "El nombre es obligatorio"
    }
    return error
}

const TaxesForm = props => {
    const classes = useStyles();
    const { handleSubmit, agreements, setFormTaxe, pristine, onCancelAction, periods, levels, onPeriodSelected, formTaxe, title  } = props
    // const { code } = formTaxe
    const handleAgreementsChange = (e) => {
        setFormTaxe(prevState => ({
                ...prevState,
                agreements: e
            }))
    }
    const handlePeriodsChange = (e) => {
        setFormTaxe(prevState => ({
                ...prevState,
                periods: e
            }))
        onPeriodSelected(e)
    }
    const handleLevelsChange = (e) => {
        setFormTaxe(prevState => ({
                ...prevState,
                levels: e
            }))
    }
    return (
        <form className={classes.form} onSubmit={ handleSubmit }>
            <Grid container spacing={3}>
                <Grid item xs={12} md={12} lg={12} xl={12}>
                    <Autocomplete
                        id="combo-box-demo"
                        value={formTaxe.agreements}
                        options={agreements}
                        getOptionLabel={(option) => (option.name) ? option.name : ""}
                        style={{ width: '100%' }}
                        onChange = { (e, nv) => {
                                        handleAgreementsChange(nv)
                                    }}
                        renderInput={(params) => <TextField {...params} label={"Seleccione " + title} variant="outlined" />}
                    />
                    {/* <FormControl variant="outlined" style = {{width: '100%'}}>
                        <InputLabel id="demo-simple-select-outlined-label">Seleccione {title}</InputLabel>
                        <Select
                            label={"Seleccione " + title}
                            labelId="demo-simple-select-label"
                            id="agreements"
                            fullWidth
                            value = { formTaxe.agreements}
                            onChange={(e) => handleAgreementsChange(e.target.value) }
                        >
                            {
                                agreements.map(option => {
                                return <MenuItem key={option.id} value={option}>{`${option.name}`}</MenuItem>
                                })
                            }
                        </Select>
                    </FormControl> */}
                </Grid>
                <Grid item xs={12} md={12} lg={12} xl={12} >
                    <FormControl variant="outlined" style = {{width: '100%',}}>
                        <InputLabel id="demo-simple-select-outlined-label">Seleccione Periodo</InputLabel>
                        <Select
                        label="Seleccione Período"
                        labelId="demo-simple-select-label"
                        id="period"
                        fullWidth
                        value = { formTaxe.periods}
                        onChange={(e) => handlePeriodsChange(e.target.value) }
                        >
                            {
                                (periods.length > 0) ? 
                                     periods.map(option => {
                                        return <MenuItem key={option.Secuencial} value={option}>{`${option.Descripcion}`}</MenuItem>
                                })
                                : <MenuItem key={1} value={1}>Seleccione</MenuItem>
                                //})
                            }
                        </Select>
                    </FormControl>
                </Grid>
                <Grid item xs={12} md={12} lg={12} xl={12}>
                    <Autocomplete
                        id="combo-box-demo"
                        value={formTaxe.levels}
                        options={levels}
                        getOptionLabel={(option) => (option.Descripcion) ? option.Descripcion : ""}
                        style={{ width: '100%' }}
                        onChange = { (e, nv) => {
                                        handleLevelsChange(nv)
                                    }}
                        renderInput={(params) => <TextField {...params} label={"Seleccione nivel"} variant="outlined" />}
                    />
                    {/* <FormControl variant="outlined" style = {{width: '100%'}}>
                        <InputLabel id="demo-simple-select-outlined-label">Seleccione Nivel</InputLabel>
                        <Select
                        label="Seleccione nivel"
                        labelId="demo-simple-select-label"
                        id="level"
                        fullWidth
                        value = { formTaxe.levels}
                        onChange={(e) => handleLevelsChange(e.target.value) }
                        >
                            {
                                levels.map(option => {
                                return <MenuItem key={option.Secuencial} value={option}>{`${option.Descripcion}`}</MenuItem>
                                })
                            }
                        </Select>
                    </FormControl> */}
                </Grid>
                <Grid item xs={12} md={12} lg={12} xl={12}>
                    <Field
                        name="name"
                        id="name"
                        autoFocus = { true }
                        component={ RenderTextFieldRedux }
                        label="Nombre o Código"
                        fullWidth
                    />
                </Grid>
                <Grid item xs={6} md={6}>
                    <Button variant="contained" type="submit"
                        fullWidth
                        color="primary"
                        disabled={pristine }
                        >
                        Consultar
                    </Button>
                </Grid>
                <Grid item xs={6} md={6}>
                    <Button variant="contained" className={classes.button} onClick = { () => onCancelAction() }>
                        Cancelar
                    </Button>
                </Grid>
            </Grid>
        </form>
    );
};

TaxesForm.propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    agreements: PropTypes.array.isRequired,
    periods: PropTypes.array.isRequired,
    levels: PropTypes.array.isRequired,
    onCancelAction: PropTypes.func.isRequired,
};

const TaxesFormReduxForm = reduxForm(
    {
      form: 'TaxesForm',
      validate
    }
)(TaxesForm)
export default TaxesFormReduxForm